import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { BannerSlot } from "./BannerSlot";
import { MobileNav } from "./MobileNav";
import { CommandPalette } from "@/components/CommandPalette";

export function AppShell() {
  const [paletteOpen, setPaletteOpen] = useState(false);

  // ⌘K / Ctrl+K öffnet die Palette global. Escape schließt sie (in der Palette selbst).
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex h-full bg-background text-foreground">
      {/* Desktop: Sidebar links. Mobil (< md): Bottom-Navigation, siehe MobileNav. */}
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header onOpenPalette={() => setPaletteOpen(true)} />
        <BannerSlot />
        {/* pb-mobile-nav: Inhalt scrollt über der fixen Bottom-Bar frei, nicht dahinter. */}
        <main className="min-h-0 flex-1 overflow-auto pb-mobile-nav md:pb-0">
          <Outlet />
        </main>
      </div>
      <MobileNav />
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </div>
  );
}
